import { PackagingEnum } from "../types/enums/packaging";

export interface IMedicationQuantityInitialValues {
    quantity: string;
}

export interface IMedicationQuantity {
    quantity?: number;
    daysSupply?: number;
    packaging?: PackagingEnum;
}

export const medicationQuantityInitialValues: IMedicationQuantityInitialValues = {
    quantity: '30',
};

export const medicationDaysSupplyOptions = [
    { label: 'Daily', value: 1 },
    { label: 'Monthly', value: 30 }
];

export const rxFillFrequencyOptions = [
    { label: 'Every 30 Days', value: 30 },
    { label: 'Every 90 Days', value: 90 }
]

export const medicationOptionalDaysSupplyOptions = [
    ...medicationDaysSupplyOptions
    // { label: 'Unsure at this time', value: 0 },
];

export const conditionalUnsureSelection = { label: 'Unsure at this time', value: 0 };
